/**
 * Normies Studio constants.
 *
 * Modes, defaults, API base URL, and mode → template/palette/generator mappings.
 */

// ── API ──
export const NORMIES_API_BASE = 'https://api.normies.art';
export const DEFAULT_NORMIES_TOKEN_ID = '4354';

// ── Modes ──
export const NORMIES_MODES = [
  {
    id: 'normie-card',
    name: 'Normie Card',
    desc: 'Portrait poster from on-chain traits',
    icon: '🖼',
    defaultTemplate: 'normies-polaroid',
    defaultPalette: 'normies-emerald',
    defaultGenerator: 'meridian',
    defaultGenPalette: 'normies-emerald',
  },
  {
    id: 'agent-card',
    name: 'Agent Card',
    desc: 'Awakened agent persona card',
    icon: '🤖',
    defaultTemplate: 'normies-polaroid',
    defaultPalette: 'normies-awakened',
    defaultGenerator: 'halftonePanel',
    defaultGenPalette: 'normies-awakened',
  },
  {
    id: 'canvas-story',
    name: 'Canvas Story',
    desc: 'Before / after canvas transformation',
    icon: '🎨',
    defaultTemplate: 'normies-before-after',
    defaultPalette: 'normies-emerald',
    defaultGenerator: 'blockMaze',
    defaultGenPalette: 'normies-mono',
  },
  {
    id: 'market-dashboard',
    name: 'Market',
    desc: 'Collection stats from OpenSea',
    icon: '📊',
    defaultTemplate: 'normies-dashboard',
    defaultPalette: 'normies-emerald',
    defaultGenerator: 'meridian',
    defaultGenPalette: 'normies-emerald',
  },
  {
    id: 'explainer',
    name: 'Explainer',
    desc: 'What is a Normie? Educational cards',
    icon: '📖',
    defaultTemplate: 'normies-explainer',
    defaultPalette: 'normies-emerald',
    defaultGenerator: 'geoComposition',
    defaultGenPalette: 'geo-arctic',
  },
  {
    id: 'burn-story',
    name: 'Burn Story',
    desc: 'Memorial for burned Normies',
    icon: '🔥',
    defaultTemplate: 'normies-burn',
    defaultPalette: 'normies-burn',
    defaultGenerator: 'sunburst',
    defaultGenPalette: 'normies-burn',
  },
  {
    id: 'gm',
    name: 'GM',
    desc: 'Daily GM post with persona',
    icon: '☀️',
    defaultTemplate: 'normies-gm',
    defaultPalette: 'normies-emerald',
    defaultGenerator: 'sunburst',
    defaultGenPalette: 'geo-forest',
  },
];

export const NORMIES_MODE_MAP = Object.fromEntries(
  NORMIES_MODES.map(m => [m.id, m])
);

// ── Normies canonical colors ──
export const NORMIES_COLORS = {
  pixelOn: '#48494b',
  pixelOff: '#e3e5e4',
  nearBlack: '#0a0a0a',
  midGray: '#737577',
  white: '#ffffff',
  offWhite: '#f5f5f0',
  awakened: '#6366f1',
  awakenedLight: '#818cf8',
  burn: '#ef4444',
};

// ── Polaroid frame color options ──
export const POLAROID_COLORS = [
  { id: 'offWhite',  label: 'Classic',   hex: '#f5f5f0' },
  { id: 'cream',     label: 'Cream',     hex: '#faf3e0' },
  { id: 'black',     label: 'Black',     hex: '#0a0a0a' },
];

export const DEFAULT_POLAROID_COLOR = '#f5f5f0';

// ── Default Normies slide data shape ──
export const DEFAULT_NORMIES_CONFIG = {
  enabled: false,
  mode: 'normie-card',
  template: 'normies-full-bg',
  tokenId: DEFAULT_NORMIES_TOKEN_ID,
  heroImage: null,
  heroImageOriginal: null,
  lastFetchedAt: null,
  apiSnapshot: null,
  generatedCopy: null,
  polaroidColor: null, // null → DEFAULT_POLAROID_COLOR
};

/**
 * Normalize a normies config — fill in missing fields with defaults.
 */
export function normalizeNormiesConfig(config) {
  if (!config) return { ...DEFAULT_NORMIES_CONFIG };
  return {
    ...DEFAULT_NORMIES_CONFIG,
    ...config,
  };
}

/**
 * Build the image URLs for a token ID.
 * Images are loaded directly (no proxy needed for <img> tags).
 */
export function buildNormieImageUrls(tokenId) {
  return {
    composited: `${NORMIES_API_BASE}/normie/${tokenId}/image.png`,
    original: `${NORMIES_API_BASE}/normie/${tokenId}/original/image.png`,
  };
}
